import {Component, Inject, OnInit, Optional, ViewChild, ViewChildren} from '@angular/core';
import {ARService} from '../../ar.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {CurrencyPipe} from '@angular/common';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Globals} from '../../../../globals';
import {DataArPaymentAuditModel} from '../../models/data-ar-payment-audit.model';
import {TdoTableV2Component} from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {TdoTableFooterDataModel} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-footer-data.model';
import {TdoTableSelectionEvent} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {DataArPaymentAuditLogModel} from '../../models/data-ar-payment-audit-log.model';
import {ArPaymentComponent} from '../ar-payment/ar-payment.component';
import {PatientDataModel} from '../../../../models/patient/patient-data.model';
import {ContactDataModel} from '../../../../models/person/contact-data.model';
import {DataARLedgerListModel} from '../../models/data-ar-ledger-list.model';
import {MessagingService} from '../../../../services/messaging.service';
import {Router} from '@angular/router';
import {MessagingConstants} from '../../../../models/MessagingConstants';
import {Constants} from '../../../../constants';
import { LEDGER_ITEM_STATUS } from 'src/app/models/constants/ledger-item-status.model';

@Component({
  standalone: false,
  selector: 'app-ar-payment-audit',
  templateUrl: './ar-payment-audit.component.html',
  styleUrls: ['./ar-payment-audit.component.css']
})
export class ArPaymentAuditComponent implements OnInit {

  @ViewChild(TdoTableV2Component) tdoTable: TdoTableV2Component;
  @ViewChildren(TdoTableV2Component) tdoTables;

  searchPredicate: (data: any, filter: string) => boolean;
  footerData: TdoTableFooterDataModel[] = [];

  isLoading: boolean = true;
  dataARPayments: DataArPaymentAuditModel[];
  dataARPaymentLogs: DataArPaymentAuditLogModel[];
  selectedPaymentID: string;
  selectedPaymentLogID: string;

  dataPatient: PatientDataModel;
  dataContact: ContactDataModel;
  dataLedgerItems: DataARLedgerListModel[] = [];

  enumLedgerItemTypeCredit: string = '00000078-1000-0000-0000-000000000001';
  enumLedgerItemTypeDebit: string = '00000078-1000-0000-0000-000000000002';
  enumCoverageTypeAmount: string = '00000048-1000-0000-0000-000000000002';
  //enumLedgerItemStatusPaid: string = '00000083-1000-0000-0000-000000000002';
  //enumLedgerItemStatusVoid: string = '00000083-1000-0000-0000-000000000003';

  paymentID: string = Constants.emptyGuid;

  constructor(
    // public dialogRef: MatDialogRef<ArPaymentAuditComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: any,
    private arService: ARService,
    private currencyPipe: CurrencyPipe,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private globals: Globals,
    private messagingService: MessagingService,
    private router: Router,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {

    this.isLoading = true;
    if (this.data?.PaymentID) {
      this.paymentID = this.data.PaymentID;
    }

    const promises = [
      this.getAuditList(this.paymentID)
    ];

    Promise.all(promises).then((results: any[]) => {

      this.dataARPayments = results[0];
      this.isLoading = false;
    }, err => {
      this.createMessage('Something went wrong', 'Error');
      this.isLoading = false;
    });
  }

  getAuditList(PaymentID: string) {
    const promise = new Promise((resolve, reject) => {
      this.arService.getPaymentAuditList(PaymentID)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  setAuditLogList() {
    // get selected payment by selected id
    // load up any included logs
    const payments = this.dataARPayments.filter(a => a.PaymetnID === this.selectedPaymentID);

    if (payments.length) {
      this.dataARPaymentLogs = payments[0].dataARPaymentsLog;
    }

    // refresh table
    this.tdoTables.toArray()[1].dataSource = this.dataARPaymentLogs;
    this.tdoTables.toArray()[1].updateData();
  }

  returnShortenedLogText(text: string) {
    if (text.length >= 130) {
      return text.substring(0, 125);
    }
    else {
      return '';
    }
  }

  showFullLogText(text: string) {
    alert(text);
    // this.createMessage(text, 'Log Text');
  }

  ViewTransactionDetails(PaymetnID: string, PaymentTransactionID: string, enumARProcessorID: string) {
    // load wp response view in popup
    // const dialogRef = this.dialog.open(ArWorldpayPaymentReturnComponent, {
    //   width: '800px',
    //   height: '600px',
    //   data: {
    //     PaymentTransactionId: PaymentTransactionID,
    //   }
    // });
    // dialogRef.afterClosed().subscribe(result => {
    //   if (result) {
    //     // popup payment window with payment already made
    //     this.createMessage('Opening Payment Distribution Window ...', 'Info');
    //     const wpResponse: WorldpayTransactionResponseModel = result;
    //     this.dataARPayments.forEach(a => {
    //       if (a.PaymetnID === this.selectedPaymentID) {
    //         a.ApprovedPaymentAmount = parseInt(wpResponse.ApprovedAmount);
    //       }
    //     });

    //     this.openPaymentWindow();
    //   }
    // }, err => {
    // });
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  // Handle selection and deselection of rows model data
  onRowSelected(event: TdoTableSelectionEvent) {
    const auditModel = this.dataARPayments.find(p => p === event.model);
    if (auditModel) {
      auditModel.DATA_SELECTED = event.isSelected;
      this.selectedPaymentID = auditModel.PaymetnID;
    }
    this.setAuditLogList();
  }

  // Handle selection and deselection of rows model data
  onRowSelectedLog(event: TdoTableSelectionEvent) {
    const auditModel = this.dataARPaymentLogs.find(p => p === event.model);
    if (auditModel) {
      auditModel.DATA_SELECTED = event.isSelected;
      this.selectedPaymentLogID = auditModel.PaymetnLogID;
    }
  }

  async openPaymentWindow() {
    if (this.selectedPaymentID) {

      // selected payment
      const payment = this.dataARPayments.filter(a => a.PaymetnID === this.selectedPaymentID);

      // get values for payment window
      const promises: any[] = [
        this.getPatientAndContact(payment[0].PatientId),
        this.getLedgerForPatient(payment[0].PatientId),
      ];

      this.isLoading = true;

      try {
        const results: any[] = await Promise.all(promises);

        this.dataPatient = results[0];
        this.dataContact = this.dataPatient.dataContact;
        this.dataLedgerItems = results[1];

        // not sure why this is here, it's from the ledger from prev dev
        this.dataLedgerItems.forEach(ledgerItem => {
          ledgerItem.DATA_SELECTED = false;
          ledgerItem.DATA_SELECTED_CLAIM = false;
        });

        // from former devs, appears to be filtering out credits
        let dataLedgerItems: DataARLedgerListModel[] = [];
        // fill the ledger items with items not paid and not credit

        dataLedgerItems = this.dataLedgerItems.filter(item => {
          //const isMarkedPaid = item.enumLedgerItemStatusID === LEDGER_ITEM_STATUS.Paid;
          const isVoid = item.enumLedgerItemStatusID === LEDGER_ITEM_STATUS.Void;
          const isMarkedCredit = item.enumARLedgerItemTypeID === this.enumLedgerItemTypeCredit;
          const isAdjustment = !item.dataARTransactionItem;
          if (isMarkedCredit || isAdjustment || isVoid) {
            return false;
          } else {
            return true;
          }
        });


        this.isLoading = false;

        // open payment window
        const dialogRef = this.dialog.open(ArPaymentComponent, {
          width: '90%',
          height: '90%',
          data: {
            dataARPaymentAudit: payment[0],
            type: 'Patient',
            PatientId: payment[0].PatientId,
            dataLedgerItems,
            dataPatient: this.dataPatient,
            dataContact: this.dataContact,
          }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            // this.init();
          }
        }, err => {
        });

      } catch (err) {
        this.isLoading = false;
        this.createMessage('Something went wrong', 'Error');
      }
    }
  }

  getPatientAndContact(PatientId: string) {
    return this.arService.getPatientAndContact(PatientId).toPromise();
  }

  getLedgerForPatient(PatientId: string) {
    return this.arService.getLedgerForPatient(PatientId).toPromise();
  }

  redirectToPatientLedger(patientId, patientName) {
    const payments = this.dataARPayments.filter(a => a.PaymetnID === this.selectedPaymentID);
    this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
      PatientID: patientId,
      PatientName: patientName,
      clearCurrentQuery: false
    });

    // send to ledger
    this.router.navigate(['/landing/ledger']);
  }
}
